var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.pageInfo.background},_vm._l((_vm.activities),function(acitivty,index){return _c('ActivityComponent',{key:index,attrs:{"activity":acitivty}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }